<template>
  <fieldset class="inline-block">
    <input
      :id="id"
      class="peer form-check hidden"
      type="checkbox"
      v-model="modelValueComputed"
      :value="value"
      :disabled="disabled"
    />
    <label
      class="t-tooltip relative flex justify-center items-center form-label border border-theme-37 cursor-pointer rounded-full p-1 text-center text-white bg-theme-37 peer-checked:bg-theme-36 peer-checked:text-white peer-checked:border-theme-36 hover:bg-theme-37 hover:border-theme-37 hover:text-white"
      :class="{ 'h-6 w-6': small, 'w-8 h-8': !small }"
      :for="id"
    >
      <span class="t-tooltip-text">{{ tooltip }}</span>
      <slot>
        <component
          :is="icon"
          :class="{ 'w-3 h-3': small, 'w-4 h-4': !small }"
        />
      </slot>
    </label>
  </fieldset>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  icon: { type: String, require: true },
  modelValue: [Array, Boolean],
  value: [String, Boolean],
  id: { type: String, require: true },
  small: Boolean,
  disabled: Boolean,
  tooltip: { type: String, default: "tooltip" },
  disabledTooltip: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["update:modelValue"]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});
</script>

